import { useMemo } from 'react';
import { useOrder } from './OrderContext';
import { OrderStep } from './order.types';

const STEP_ORDER: OrderStep[] = ['cart', 'dietary', 'delivery', 'summary', 'submitted'];

/**
 * Custom hook to manage order step navigation.
 *
 * Returns the current step, navigation functions, and flags.
 */
export const useOrderStep = () => {
  const { state, setStep } = useOrder();

  const stepMap = useMemo(() => {
    const map = new Map<OrderStep, number>();
    STEP_ORDER.forEach((step, index) => map.set(step, index));
    return map;
  }, []);

  const currentIndex = stepMap.get(state.step) ?? 0;

  const nextStep = () => {
    const next = STEP_ORDER[currentIndex + 1];
    if (next) setStep(next);
  };

  const prevStep = () => {
    const prev = STEP_ORDER[currentIndex - 1];
    if (prev) setStep(prev);
  };

  return {
    step: state.step,
    nextStep,
    prevStep,
    setStep,
    isFirstStep: currentIndex === 0,
    isLastStep: currentIndex === STEP_ORDER.length - 1,
  };
};
